/**@type Image[]*/
import IMAGES from "../js/images";
/**@type Label[]*/
import LABELS from "../js/labels";
/**@type string*/
import videoMobileSrc from "../img/video1-mobile.mp4";
/**@type string*/
import videoSrc from "../img/video1.mp4";
/**@type string*/
import videoPosterMobileSrc from "../img/video1-f000112-mobile.webp";
/**@type string*/
import videoPosterSrc from "../img/video1-f000112.webp";

document.documentElement.style.setProperty("--gallery-section-width-coefficient", import.meta.env.VITE_GALLERY_SECTION_WIDTH);
// noinspection JSCheckFunctionSignatures
document.documentElement.style.setProperty("--gallery-number-of-sections", Math.max(...(IMAGES.map(i => i.section))) + 1);
document.querySelector("#home video").poster = window.screen.width < 425 ? videoPosterMobileSrc : videoPosterSrc;

let uriHashChangeDisabled = false;

function initScrolling() {
  document.querySelectorAll("a[href^=\"#\"]").forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      window.location.hash = this.getAttribute("href");
      // noinspection JSIgnoredPromiseFromCall
      disableUriHashChangeTemporarily();
      document.querySelector(this.getAttribute("href")).scrollIntoView({
        behavior: "smooth"
      });
      dispatchEvent(new CustomEvent("section-change", {detail: this.getAttribute("href").replace("#", "")}));
    });
  });
}

async function disableUriHashChangeTemporarily() {
  uriHashChangeDisabled = true;
  await new Promise(r => setTimeout(r, 1000));
  uriHashChangeDisabled = false;
}

function getIndexInParent(element, isMobile) {
  let children = element.parentElement.querySelectorAll(`:scope > :not(${ isMobile ? ".only-desktop)" : ".only-mobile)" }`);

  for (let i = 0; i < children.length; i++) {
    let child = children[i];

    if (child.id === element.id) {
      return i;
    }
  }

  return 0;
}

function handleSectionChange(sectionId) {
  const isMobile = screen.width < 789;
  let target = document.getElementById(sectionId);
  let indexInParent = getIndexInParent(target, isMobile);
  let dots = document.getElementsByClassName("nav-bar")[0].querySelectorAll(`:scope > :not(${ isMobile ? ".only-desktop)" : ".only-mobile)" }`);

  for (let i = 0; i < dots.length; i++) {
    let elem = dots[i];

    if (i === indexInParent) {
      elem.classList.add("selected");
    } else {
      elem.classList.remove("selected");
    }
  }

  let headerButtons = document.getElementsByClassName("header")[0].children;

  for (let i = 0; i < headerButtons.length; i++) {
    let button = headerButtons[i];
    if (button.role === "button") {
      let internalSpan = button.children[0];

      if (sectionId === internalSpan.textContent.toLowerCase()) {
        internalSpan.classList.add("selected");
        if (!uriHashChangeDisabled) window.location.hash = "#" + sectionId;
      } else {
        internalSpan.classList.remove("selected");
      }
    }
  }

  if (sectionId !== "home") {
    pauseVideo();
  } else {
    playVideo();
  }

}


let observer = (allTargets) => new IntersectionObserver((entries) => {
  let target = entries[0].target.id;
  for (const t of allTargets) {
    t.id === target ? t.classList.add("in-view") : t.classList.remove("in-view");
  }
  dispatchEvent(new CustomEvent("section-change", {detail: target}));
}, {
  rootMargin: "0px",
  threshold: .60,
});


function initIntersectionObservers() {
  let targets = document.getElementsByClassName("section");
  const o = observer(targets);
  for (let i = 0; i < targets.length; i++) {
    const target = targets[i];
    o.observe(target);
  }
}

function playVideo() {
  const video = document.querySelector("#home video");
  video.play();
}

function loadVideo() {
  const video = document.querySelector("#home video");
  const videoSource = video.querySelector("source");
  videoSource.src = window.screen.width < 480 ? videoMobileSrc : videoSrc;
  video.load();
}

function pauseVideo() {
  const video = document.querySelector("#home video");
  video.pause();
}

function initGallery() {
  if (!("content" in document.createElement("template"))) {
    console.warn("Browser does not support templates!");
    return;
  }
  initPaintingsAndLabels();
}


export function initPaintingsAndLabels(replaceExisting = false) {
  let container = document.querySelector(".gallery-container");
  let templateContent = document.querySelector("#gallery-painting-template").content;

  const paintingsOverlaysByUrl = {};
  for (let i = 0; i < IMAGES.length; i++) {
    let im = IMAGES[i];
    let clone = undefined;
    let painting = undefined;
    let imageSrc = "/thmb/" + im.url;
    if (!replaceExisting) {
      clone = templateContent.cloneNode(true);
      painting = clone.children[0];
    } else {
      painting = container.querySelector(`.painting:has( img[src='${ imageSrc }'])`);
    }

    let imTag = painting.querySelector("img");
    imTag.src = imageSrc;
    imTag.alt = im.title;
    imTag.height = im.sizePx.height;
    imTag.width = im.sizePx.width;
    painting.style.left = `calc(${ im.section } * var(--gallery-section-width) + ${ im.positionXOffset }px)`;
    painting.style.top = "calc(50vh - " + im.positionY + "px)";

    painting.addEventListener("click", (e) => {
      e.stopPropagation();
      //history.pushState({}, "", "/full/" + im.url);
      window.location.href = "/full/" + im.url;
    });

    painting.addEventListener("mouseenter", () => {
      // noinspection JSClosureCompilerSyntax
      const img = new Image();
      img.src = "/full/" + im.url;
    });

    paintingsOverlaysByUrl[im.url] = painting.querySelector(".overlay");
    paintingsOverlaysByUrl[im.url].style.fontSize = Math.min(im.sizePx.width, im.sizePx.height) + "px";

    if (!replaceExisting) {
      container.appendChild(clone);
    }
  }

  let template = document.querySelector("#gallery-label-template").content;
  let labelTemplateContent = document.querySelector("#gallery-label-content-template").content;

  LABELS.forEach(labelSpec => {
    let clone = undefined;
    let label = undefined;
    if (!replaceExisting) {
      clone = template.cloneNode(true);
      label = clone.children[0];
    } else {
      label = container.querySelector(`#label-${ labelSpec.id }`);
    }

    const relatedPaintings = IMAGES.filter(im => im.labelId === labelSpec.id);

    for (let j = 0; j < relatedPaintings.length; j++) {

      const im = relatedPaintings[j];
      let content = labelTemplateContent.cloneNode(true);
      content.querySelector(".index").textContent = j + 1 + ")";
      content.querySelector(".title").textContent = im.title;
      content.querySelector(".additional-info").textContent = `${ im.year } | ${ im.media } | ${ im.sizeCm.height } X ${ im.sizeCm.width } cm`;
      let base = im.sizeCm.width * 2 + im.sizeCm.height * 2;
      const price = im.price ? im.price < 1 ? undefined : im.price : 100 + 1 / (1 + Math.E ** (-((base - 290) / 100))) ** 2 * 10000;  //fixme move to loader
      content.querySelector(".price").textContent = price ? Math.round(price) + "€" : undefined;

      if (!im.sold) {
        let sold = content.querySelector(".sold");
        content.children[0].removeChild(sold);
      }

      let paintingOverlay = paintingsOverlaysByUrl[im.url];
      paintingOverlay.textContent = (j + 1);

      label.appendChild(content);
    }

    label.style.left = `calc(${ labelSpec.section } * var(--gallery-section-width) + ${ labelSpec.positionXOffset }px - 150px)`;
    label.style.top = `calc(${ labelSpec.positionY }px + 50vh)`;
    label.id = "label-" + labelSpec.id;

    let timeout_id = 0;
    let triggered = false;
    let originalPosX = undefined;
    let originalPosY = undefined;

    let isTouchScreen = window.matchMedia("(pointer: coarse)").matches;
    let mousedown = isTouchScreen ? "touchstart" : "mousedown";
    let mousemove = isTouchScreen ? "touchmove" : "mousemove";
    let mouseup = isTouchScreen ? "touchend" : "mouseup";
    const _getClientXY = isTouchScreen ? (e) => [e.touches[0].clientX, e.touches[0].clientY] : (e) => [e.clientX, e.clientY];

    label.addEventListener(mousedown, (event) => {
      timeout_id = setTimeout(() => {
        triggered = true;
      }, 200);

      event.stopPropagation();


      let onMousemove = undefined;
      let isSelected = label.classList.contains("selected");

      if (isSelected) {
        event.preventDefault();

        let l = label.offsetLeft;
        let t = label.offsetTop;

        let startPos = _getClientXY(event);

        onMousemove = (event) => {
          event.preventDefault();
          event.stopPropagation();
          let pos = _getClientXY(event);

          label.style.left = l + (pos[0] - startPos[0]) + "px";
          label.style.top = t + (pos[1] - startPos[1]) + "px";
        };
      }

      const onMouseup = () => {
        clearTimeout(timeout_id);
        document.removeEventListener(mousemove, onMousemove);
        document.removeEventListener(mouseup, onMouseup);
        if (!triggered) {
          if (isSelected) {
            label.classList.remove("selected");
            relatedPaintings.map(im => paintingsOverlaysByUrl[im.url]).forEach((p) => {
              p.style.opacity = "0";
            });
            label.style.left = originalPosX;
            label.style.top = originalPosY;
          } else {
            label.classList.add("selected");
            relatedPaintings.map(im => paintingsOverlaysByUrl[im.url]).forEach((p) => {
              p.style.opacity = "0.5";
            });
            originalPosX = label.style.left;
            originalPosY = label.style.top;
          }
        } else {
          triggered = false;
        }
      };

      if (isSelected) {
        document.addEventListener(mousemove, onMousemove, {passive: false});
      }

      document.addEventListener(mouseup, onMouseup);
    }, {passive: false});

    if (!replaceExisting) container.appendChild(clone);
  });
}

function initAbout() {
  const aboutTheArtistTemplate = document.querySelector("#about-the-artist-text-template").content;
  let aboutTheArtistContainers = document.querySelectorAll(".about-the-artist-text");

  for (const container of aboutTheArtistContainers) {
    if (!container.children.length) {
      container.appendChild(aboutTheArtistTemplate.cloneNode(true));
    }
  }

  const servicesOfferedTemplate = document.querySelector("#services-offered-text-template").content;
  let servicesOfferedContainers = document.querySelectorAll(".services-offered-text");

  for (const container of servicesOfferedContainers) {
    if (!container.children.length) {
      container.appendChild(servicesOfferedTemplate.cloneNode(true));
    }
  }

}

addEventListener("load", () => {
  initScrolling();
  initIntersectionObservers();
  initGallery();
  loadVideo();
  playVideo();
  initAbout();
});

addEventListener("section-change", (e) => {
  handleSectionChange(e.detail);
});


/**
 * @typedef {object} Image
 * @property {string} url
 * @property {string} title
 * @property {string} year
 * @property {string} media
 * @property {boolean} sold
 * @property {?number} price
 * @property {number} labelId
 * @property {Size} sizeCm
 * @property {Size} sizePx
 * @property {number} section
 * @property {number} positionXOffset
 * @property {number} positionY
 */

/**
 * @typedef {object} Size
 * @property {number} width
 * @property {number} height
 */

/**
 * @typedef {object} Label
 * @property {number} id
 * @property {number} section
 * @property {number} positionXOffset
 * @property {number} positionY
 */
